import gql from 'graphql-tag'
import {useQuery} from '@apollo/client'

const querySavedFilters = gql`
  query savedFilters {
    savedFilters {
      saved_filter_name
      saved_filter_values {
        FILTER_NAME
        FILTER_KEY
        FILTER_CATEGORY_ID
      }
    }
  }
`

export default function useQuerySavedFiltersList() {
  const {
    data: savedFiltersListData,
    loading: loadingSavedListFilters,
    refetch: refetchSavedFiltersList,
    error: errorLoadingSavedFiltersList
  } = useQuery(querySavedFilters, {
    notifyOnNetworkStatusChange: true,
    errorPolicy: 'all'
  })

  return {savedFiltersListData, loadingSavedListFilters, refetchSavedFiltersList, errorLoadingSavedFiltersList}
}
